import { Checkbox } from 'antd';
import styled from 'styled-components';

export const TableWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  margin-top: 1em;
`;

export const IncludeCommentsCheckbox = styled(Checkbox)`
  margin-top: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;

  button:not(:last-of-type) {
    margin-right: 0.5rem;
  }
`;
